import { render, staticRenderFns } from "./WorkRecordDetail.vue?vue&type=template&id=0462d296&scoped=true"
import script from "./WorkRecordDetail.vue?vue&type=script&lang=js"
export * from "./WorkRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordDetail.vue?vue&type=style&index=0&id=0462d296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462d296",
  null
  
)

export default component.exports